export const DEFAULT_OVERLAY_CONFIG = {
    WIDTH: "100vw",
    HEIGHT: "100vh",
    COLOR: "black",
    OPACITY: 0.3,
    TRANSITION_DURATION: "0.3s",
} as const;
